import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import format from 'date-fns/format';

import { FlightInfoEndpoint_segment$key } from '__generated__/FlightInfoEndpoint_segment.graphql';
import Box from '@mui/material/Box';

type Props = {
  segment: FlightInfoEndpoint_segment$key;
  variant: 'forward' | 'return';
};

const FlightInfoEndpoint: FC<Props> = ({ segment, variant }) => {
  const {
    departAirportCode,
    departDatetime,
    arrivalAirportCode,
    arrivalDatetime,
  } = useFragment(
    graphql`
      fragment FlightInfoEndpoint_segment on FlightSegment {
        departAirportCode
        departDatetime
        arrivalAirportCode
        arrivalDatetime
      }
    `,
    segment
  );

  const date = variant === 'forward' ? departDatetime : arrivalDatetime;
  const airport =
    variant === 'forward' ? departAirportCode : arrivalAirportCode;

  return (
    <Box sx={{ display: 'flex' }}>
      <Box
        sx={{
          fontWeight: 500,
          mb: 1,
        }}>
        {format(new Date(date), 'HH:mm')} {airport}
      </Box>
    </Box>
  );
};

export default FlightInfoEndpoint;
